import { signupApi } from 'app/services/signup'

export interface SubscriptionGroupDetailParams {
  quoteId: string
  optedIn: boolean
  subscriptionGroupName: string
}

const subscriptionGroupApi = signupApi.injectEndpoints({
  endpoints: (builder) => ({
    saveSubscriptionGroupDetail: builder.mutation<void, SubscriptionGroupDetailParams>({
      query: (params) => ({
        url: 'subscription-group',
        method: 'POST',
        data: params,
      }),
    }),
  }),
})

const { useSaveSubscriptionGroupDetailMutation } = subscriptionGroupApi

export { subscriptionGroupApi, useSaveSubscriptionGroupDetailMutation }
